import styled, { css } from 'styled-components';
import COLORS from '../../common/styles/color-pallete';
import { FONT_FAMILY } from '../../common/styles/fontStyles';

const InputWrapper = styled.div<{
  $valueExist: boolean;
  disabled?: boolean;
  $invalid?: boolean;
  delayTransaction?: boolean;
  $messagePadding?: boolean;
  $message?: boolean;
  $errorPadding?: boolean;
  $responsive?: boolean;
  $noErrMsg?: boolean;
}>`
  box-sizing: border-box;
  width: 325px;
  position: relative;
  border-radius: 4px;
  display: flex;
  transition: all 0.2s ease-in;
  flex-direction: column;
  position: relative;
  font-family: ${FONT_FAMILY.hellix.regular} !important;
  @media only screen and (max-device-width: 320px) {
    width: ${(p) => (p.$responsive ? '215px !important' : '100%')};
    div {
      input {
        padding-left: ${(p) => p.$responsive && '8px !important'};
      }
      label {
        left: ${(p) => p.$responsive && '8px !important'};
      }
    }
  }
  @media only screen and (min-width: 321px) and (max-device-width: 900px) and (orientation: landscape) {
    width: 100%;
  }
  input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0 50px #fff inset;
  }
  ::-webkit-input-placeholder {
    visibility: hidden;
  }
  .input-message {
    font-size: 12px !important;
    line-height: 16px !important;
    color: #333 !important;
    font-family: ${FONT_FAMILY.hellix.regular} !important;
  }
  .input-error-msg {
    font-family: ${FONT_FAMILY.hellix.regular} !important;
    bottom: 42px !important;
  }
  p {
    font-size: 16px;
    line-height: 22px !important;
    position: absolute;
    bottom: ${(p) => (p.$message ? '12px' : '8px')};
    left: 0;
    color: ${(p) => (p.$invalid ? '#FE0000' : '#f20095')} !important;
    animation: animateText 0.5s;
  }
  @keyframes animateText {
    0% {
      opacity: 0;
      transform: translateY(-2px);
    }
    30% {
      opacity: 0;
    }
    100% {
      opacity: 1;
      transform: translateY(0px);
    }
  }
  div {
    position: relative;
    height: 50px;
    margin-bottom: ${(p) =>
      p.$errorPadding
        ? '30px'
        : p.$noErrMsg
        ? '50px'
        : p.$message && p.$invalid
        ? '65px'
        : p.$message
        ? '50px'
        : p.$invalid
        ? p.$messagePadding
          ? '50px'
          : '30px'
        : '20px'};
    width: 100%;
    border: 1px solid
      ${(p) =>
        p.$invalid ? '#FE0000' : p.disabled ? '#A9A9A9' : p.$valueExist ? '#F0F0F0' : '#A9A9A9'};
    border-radius: 4px;
    background-color: ${COLORS.white};
    display: flex;
    flex-direction: row;
    transition: all 0.2s ease-in;
    label {
      position: absolute;
      left: 19px;
      top: 50%;
      font-weight: 400;
      transform: translateY(-50%);
      background-color: inherit;
      transition: all 0.1s ease-in;
      transition-delay: ${(p) => (p.delayTransaction ? '.2s' : '0s')};
      color: ${(p) => (p.$invalid ? '#FE0000' : p.disabled ? '#a9a9a9' : '#747474')} !important;
      border: none;
      ${(p) =>
        p.$valueExist &&
        css`
          z-index: 2;
          top: 0px;
          left: 16px;
          padding: 0 4px;
          font-size: 14px;
          color: ${p.$invalid ? '#FE0000' : p.disabled ? '#a9a9a9' : '#000'} !important;
        `}
    }
    label:hover {
      border: none;
    }
    input {
      outline: none;
      border: none;
      font-size: 18px;
      padding-left: 19px;
      border-radius: 4px;
      background-color: ${COLORS.white};
      font-family: ${FONT_FAMILY.hellix.regular} !important;
      color: ${(p) => (p.disabled ? '#a9a9a9' : '#333')} !important;
      min-width: 78px;
      flex: 2;
      caret-color: ${(p) => (p.$invalid ? '#FE0000' : '#f20095')};
    }
    input:disabled {
      color: ${COLORS.textLightGrey};
      background-color: ${COLORS.white};
    }
    img {
      height: 20px;
      width: 20px;
      align-self: center;
      margin-right: 13px;
      cursor: pointer;
      box-sizing: border-box;
    }
    img:hover {
      border: none;
    }
    &:hover {
      border: 1px solid ${(p) => (p.$invalid ? '#FE0000' : p.disabled ? '#A9A9A9' : '#000')};
    }
  }

  .line-through {
    text-decoration: line-through;
  }
  .err-msg {
    color: #fe0000;
    font-size: 12px;
  }

  &:focus-within {
    z-index: 1;
    border-color: ${(p) => (p.$invalid ? '#FE0000' : '#000')};
    div {
      label {
        top: 0px;
        left: 16px;
        padding: 0 4px;
        font-size: 14px;
        color: ${(p) => (p.$invalid ? '#FE0000' : '#000')};
        border: none;
      }
    }
  }
`;

export default InputWrapper;
